export const messageHistoryCopyDe = {
    title: "Nachrichtenverlauf",
    noMessages: "Keine Nachrichten gefunden",
    viewMessages: "Nachrichten anzeigen",
    to: "An:",
    from: "Von:",
    subject: "Betreff:",
    statusClicked: "Geklickt",
    statusRead: "Gelesen",
    statusReadAt: "um",
    statusDelivered: "Zugestellt",
    statusSent: "Gesendet",
    statusPending: "Ausstehend",
    channelEmail: "E-Mail",
    channelSms: "SMS",
    retentionNotice: "Nachrichten werden nur 30 Tage aufbewahrt",
};
